/*
 * query params of the four close_versions reads. Pure; each sends exactly the fields its handler
 * reads (close_versions_enums.json request_fields_read), every month as YYYY-MM.
 */
import { PAGE_SIZE, multi_version_on } from './params';

const filters = (pay_month, state, mode) => ({
  pay_month,
  mode,
  only_changed: state.only_changed ? 'true' : 'false',
  multi_version: multi_version_on(state, mode) ? 'true' : 'false',
  q: state.q.trim(),
  sort: state.sort,
  dir: state.dir
});

export const summary_params = (pay_month) => ({ pay_month });

export const list_params = (pay_month, state, mode) => ({
  ...filters(pay_month, state, mode),
  limit: PAGE_SIZE,
  offset: state.offset
});

export const csv_params = (pay_month, state, mode) => filters(pay_month, state, mode);

export const teacher_month_params = (pay_month, teacher_uuid) => ({ pay_month, teacher_uuid });

// enums csv_file_name; used only when the server's Content-Disposition name is unreadable.
export const csv_fallback_name = (mode, pay_month) =>
  `teacher_payments_close_versions_${String(mode).toLowerCase()}_${pay_month}.csv`;
